// ---------------------------------------------------------------------------
// Safety domain types
// Ported from trusstor_dashboard/shared/interfaces/IMinimalSafetyEventForClient.ts
//             trusstor_dashboard/shared/constants/safety.const.ts
//             trusstor_dashboard/shared/constants/statuses.const.ts
// ---------------------------------------------------------------------------

import { z } from 'zod';
import { minimizedProfessionSchema, tradeSchema } from './profession.js';
import { managerSchema } from './manager.js';

// ---------------------------------------------------------------------------
// SafetyViolationTypes
// (from trusstor_dashboard/shared/constants/safety.const.ts)
// ---------------------------------------------------------------------------

export enum SafetyViolationTypes {
	dangerousActivity = 'dangerousActivity',
	unscheduledLoneWork = 'unscheduledLoneWork',
	unaccompaniedGuest = 'unaccompaniedGuest',
	sos = 'sos',
	requiredRoleOnSite = 'requiredRoleOnSite',
	workersShiftExceeded = 'workersShiftExceeded',
	certificateExpired = 'certificateExpired',
	hoistOperatorRequired = 'hoistOperatorRequired',
	restrictedArea = 'restrictedArea',
	safetyIssue = 'safetyIssue',
}

// ---------------------------------------------------------------------------
// SafetyEventStatuses
// (from trusstor_dashboard/shared/constants/statuses.const.ts)
// ---------------------------------------------------------------------------

export enum SafetyEventStatuses {
	close = 'close',
	active = 'active',
}

// ---------------------------------------------------------------------------
// minimalSafetyEventForClientSchema / IMinimalSafetyEventForClient
// (from trusstor_dashboard/shared/interfaces/IMinimalSafetyEventForClient.ts)
// ---------------------------------------------------------------------------

export const minimalSafetyEventForClientSchema = z
	.object({
		_id: z.string(),
		status: z.enum(SafetyEventStatuses),
		safetyViolationType: z.enum(SafetyViolationTypes),
		isCritical: z.boolean(),
		profession: minimizedProfessionSchema.nullable(),
		trade: tradeSchema.nullable(),
		manager: managerSchema.nullable(),
		// `.nullish()`, not `.nullable()`: a site-level violation has no floor and
		// upstream OMITS the fields rather than nulling them. Requiring them
		// present-but-null failed every such event, and since the array was
		// parsed as one unit, one of them emptied the entire feed.
		floorNick: z.string().nullish(),
		floorId: z.string().nullish(),
		timestampCreated: z.number(),
		timestampClosed: z.number().nullable(),
		linkedIssueId: z.string().optional(),
	})
	.passthrough();

export type IMinimalSafetyEventForClient = z.infer<typeof minimalSafetyEventForClientSchema>;
